module.exports = __webpack_public_path__ + "img/11.1c673b13.png";